// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"d86c4d55","148":"fadf13cd","231":"e276f25d","355":"fadf13cd","360":"c309e869","451":"d9ef8d95","555":"fadf13cd","659":"725d6f5e","897":"1c96f4b6","906":"86f6193b"}[chunkId] + ".chunk.css";
};